import { h, Component } from 'preact';
import { Router } from 'preact-router';

// import Header from './header';
import Main from './main';
// import Skill from './skill';
import About from './about';
import Work from './work';
import BestChat from './bestchat';
import ArtScene from './artscene';
import HackerNews from './hackernews';
import HeyTask from './heytask';
import Achievr from './achievr';
import Footer from './footer';
import Home from '../routes/home';
import Profile from '../routes/profile';
// import Home from 'async!../routes/home';
// import Profile from 'async!../routes/profile';

// const LineChart = require("react-chartjs").Line;

export default class App extends Component {

	/** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
	handleRoute = e => {
		this.currentUrl = e.url;
	};

	render() {
		return (
			<div id="app">
				<Main />
				<About />
        <BestChat />
        <HackerNews />
        <ArtScene />
        <HeyTask />
        <Achievr />
        <Footer />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js